import { ColDef } from '~components/dataGrids/interfaces/colDef';

interface Webhook {
	id: string;
	clientId?: string;
	scope?: string;
	tokenEndpoint?: string;
	webhookEndpoint?: string;
}

export default Webhook;

export const webhookGridCols: Record<string, ColDef<Webhook>> = {
	clientId: {
		field: 'clientId',
		headerName: 'entities:webhook.labels.clientId',
		defaultShown: true,
	},
	scope: {
		field: 'scope',
		headerName: 'entities:webhook.labels.scope',
		defaultShown: true,
	},
};
